/**
 * Profile API
 * 
 * Handles user profile management and updates.
 */

import { apiGet, apiPut, apiDelete } from '../api';

export interface ProfileUpdateRequest {
  // New name fields (v0.8.0)
  first_name?: string;
  last_name?: string;
  public_name_mode?: 'full' | 'first_last_initial' | 'first_only' | 'anonymous';
  // Legacy field for compatibility
  name?: string;
  tagline?: string;
  birthday_day?: number | null;
  birthday_month?: number | null;
  location?: string;
  primary_sport?: string;
  secondary_sports?: string[];
}

export interface User {
  id: string;
  email: string;
  name: string;
  first_name: string | null;
  last_name: string | null;
  public_name_mode: 'full' | 'first_last_initial' | 'first_only' | 'anonymous';
  public_display_name: string;
  tagline: string | null;
  birthday_day: number | null;
  birthday_month: number | null;
  location: string | null;
  primary_sport: string | null;
  secondary_sports: string[] | null;
  profile_image_url: string | null;
  user_level: string;
  subscription_level: string | null;
  created_at: string;
  updated_at: string;
}

export interface ProfileResponse {
  profile: User;
}

export const profileApi = {
  /**
   * Get current user's profile
   * GET /profile
   */
  getProfile: () => apiGet<ProfileResponse>('/profile'),

  /**
   * Update current user's profile
   * PUT /profile
   */
  updateProfile: (data: ProfileUpdateRequest) => 
    apiPut<ProfileResponse>('/profile', data),

  /**
   * Remove profile image
   * DELETE /profile/image
   */
  removeProfileImage: () => 
    apiDelete<{ ok: boolean }>('/profile/image'),
};
